module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('span', [_vm._v("我的收藏")])]), _vm._v(" "), _c('span', {
    staticClass: "back"
  }, [_c('i', {
    staticClass: "material-icons contentList"
  }, [_vm._v("")])])]), _vm._v(" "), _c('a', {
    staticClass: "weui-media-box weui-media-box_appmsg save_singerList",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('div', {
    staticClass: "weui-media-box__hd"
  }, [_c('img', {
    staticClass: "weui-media-box__thumb",
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-media-box__bd"
  }, [_c('h4', {
    staticClass: "weui-media-box__title"
  }, [_vm._v("song")]), _vm._v(" "), _c('p', {
    staticClass: "weui-media-box__desc"
  }, [_c('span', [_vm._v("singer: ")]), _vm._v(" "), _c('span', [_vm._v("8888")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52924d26"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xshoucang.vue
// module id = 260
// module chunks = 0